import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.array.includes";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { USER_AUTH, SYS_BUTTON_AUTH } from "@/store/mutation-types";
export function disabledAuthFilter(code, formData) {
  if (nodeDisabledAuth(code, formData)) {
    return true;
  } else {
    return globalDisabledAuth(code);
  }
}

function nodeDisabledAuth(code, formData) {
  console.log("页面权限禁用--NODE--开始");
  var permissionList = [];

  try {
    var obj = formData; //console.log("页面权限禁用--NODE--开始",obj);

    if (obj) {
      var bpmList = obj.permissionList;

      var _iterator = _createForOfIteratorHelper(bpmList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var bpm = _step.value;

          if (bpm.type == '2') {
            permissionList.push(bpm);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  } catch (e) {//console.log("页面权限异常----", e);
  }

  if (permissionList === null || permissionList === "" || permissionList === undefined || permissionList.length <= 0) {
    return false;
  }

  var permissions = [];

  for (var _i = 0, _permissionList = permissionList; _i < _permissionList.length; _i++) {
    var item = _permissionList[_i];

    if (item.type == '2') {
      permissions.push(item.action);
    }
  } //console.log("页面权限----"+code);


  if (!permissions.includes(code)) {
    return false;
  } else {
    var _iterator2 = _createForOfIteratorHelper(permissionList),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item2 = _step2.value;

        if (code === item2.action) {
          console.log("页面权限禁用--NODE--生效");
          return true;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return false;
}

function globalDisabledAuth(code) {
  console.log("页面禁用权限--Global--开始");
  var permissionList = [];
  var allPermissionList = []; //let authList = Vue.ls.get(USER_AUTH);

  var authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");

  var _iterator3 = _createForOfIteratorHelper(authList),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var auth = _step3.value;

      if (auth.type == '2') {
        permissionList.push(auth);
      }
    } //console.log("页面禁用权限--Global--",sessionStorage.getItem(SYS_BUTTON_AUTH));

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var allAuthList = JSON.parse(sessionStorage.getItem(SYS_BUTTON_AUTH) || "[]");

  var _iterator4 = _createForOfIteratorHelper(allAuthList),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var gauth = _step4.value;

      if (gauth.type == '2') {
        allPermissionList.push(gauth);
      }
    } //设置全局配置是否有命中

  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  var gFlag = false; //禁用命中

  var invalidFlag = false; //无效命中

  if (allPermissionList != null && allPermissionList != "" && allPermissionList != undefined && allPermissionList.length > 0) {
    var _iterator5 = _createForOfIteratorHelper(allPermissionList),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var itemG = _step5.value;

        if (code === itemG.action) {
          if (itemG.status == '0') {
            invalidFlag = true;
            break;
          } else {
            gFlag = true;
            break;
          }
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  if (invalidFlag) {
    return false;
  }

  if (permissionList === null || permissionList === "" || permissionList === undefined || permissionList.length <= 0) {
    return gFlag;
  }

  var permissions = [];

  for (var _i2 = 0, _permissionList2 = permissionList; _i2 < _permissionList2.length; _i2++) {
    var item = _permissionList2[_i2];

    if (item.type == '2') {
      permissions.push(item.action);
    }
  } //console.log("页面禁用权限----"+code);


  if (!permissions.includes(code)) {
    return gFlag;
  } else {
    var _iterator6 = _createForOfIteratorHelper(permissionList),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var item2 = _step6.value;

        if (code === item2.action) {
          console.log("页面权限解除禁用--Global--生效");
          gFlag = false;
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    return gFlag;
  }
}

export function colAuthFilter(columns, pre) {
  var authList = getNoAuthCols(pre);
  var cols = columns.filter(function (item) {
    if (hasColoum(item, authList)) {
      return true;
    }

    return false;
  });
  return cols;
}

function hasColoum(item, authList) {
  if (authList.includes(item.dataIndex)) {
    return false;
  }

  return true;
} //权限无效时不做控制，有效时控制，只能控制 显示不显示
//根据授权码前缀获取未授权的列信息


function getNoAuthCols(pre) {
  var permissionList = [];
  var allPermissionList = []; //let authList = Vue.ls.get(USER_AUTH);

  var authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");

  var _iterator7 = _createForOfIteratorHelper(authList),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var auth = _step7.value;

      //显示策略，有效状态
      if (auth.type == '1' && startWith(auth.action, pre)) {
        permissionList.push(substrPre(auth.action, pre));
      }
    } //console.log("页面禁用权限--Global--",sessionStorage.getItem(SYS_BUTTON_AUTH));

  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  var allAuthList = JSON.parse(sessionStorage.getItem(SYS_BUTTON_AUTH) || "[]");

  var _iterator8 = _createForOfIteratorHelper(allAuthList),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var gauth = _step8.value;

      //显示策略，有效状态
      if (gauth.type == '1' && gauth.status == '1' && startWith(gauth.action, pre)) {
        allPermissionList.push(substrPre(gauth.action, pre));
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  var cols = allPermissionList.filter(function (item) {
    if (permissionList.includes(item)) {
      return false;
    }

    return true;
  });
  return cols;
}

function startWith(str, pre) {
  if (pre == null || pre == "" || str == null || str == "" || str.length == 0 || pre.length > str.length) return false;
  if (str.substr(0, pre.length) == pre) return true;else return false;
}

function substrPre(str, pre) {
  return str.substr(pre.length);
}